import React, { Component } from 'react';
import { Popover, ArrowContainer } from 'react-tiny-popover';
import './MultyImagePopOver.scss';
import ImgTag from '../ImgTag';
import addButtonWhite from '../../../../assets/icons/ic_add_blue.png';
import attachImage from '../../../../assets/icons/ic_attachment.png';
import Button from '../Button';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { updateBotValue, successGenericDataGet, blockUiFun, reloginUser } from '../../../Redux/Actions/uiActions';
import { upload } from '../../../Utils/index';
import { rlibfn } from 'react-ui-lib';
class MultyImagePopOver extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isGeneric: false,
            popoverObj: false,
            isOpen: false,
            image1: this.props.custom && this.props.custom.length ? this.props.custom[0] : '',
            image2: this.props.custom && this.props.custom.length ? this.props.custom[1] : '',
            image3: this.props.custom && this.props.custom.length ? this.props.custom[2] : '',
            image4: this.props.custom && this.props.custom.length ? this.props.custom[3] : '',
            image5: this.props.custom && this.props.custom.length ? this.props.custom[4] : '',
            uploaded1: false,
            uploaded2: false,
            uploaded3: false,
            uploaded4: false,
            uploaded5: false,
            upLoading: false,
            groupDesc: 'Please attach an image which is Min. 24 x 24 px and Max. 148 x 148 px with 72 DPI, in jpg/jpeg/svg/png format only'
        }
    }

    componentDidMount() {
        const firstParam = this.props.location.pathname.split('/')[1];
        if (firstParam === 'genericconfig' && !this.state.isGeneric) {
            this.setState({ isGeneric: true })
        } else if (this.state.isGeneric) {
            this.setState({ isGeneric: false })
        }
    }

    addButton = (imageSrc) => {
        return (
            <span className='eb-icon-btn-image'>
                <ImgTag
                    className='image'
                    src={imageSrc}
                    alt='Add'
                />
            </span>
        );
    }

    imageUploadValidation = (e, id) => {
        window.URL = window.URL || window.webkitURL;
        let that = this;
        const botId = window.localStorage.getItem('bot_id');
        e.preventDefault();
        let files = e.currentTarget.files;

        let formData = new FormData();
        for (var i = 0; i < files.length; i++) {
            formData.append('file', files[i]);

            const idxDot = files[i].name.lastIndexOf(".") + 1;
            const extFile = files[i].name.substr(idxDot, files[i].name.length).toLowerCase();
            if (extFile == "jpg" || extFile == "jpeg" || extFile == "png" || extFile == "svg") {

            } else {
                rlibfn.showFlashMessage({message: `Only jpg/jpeg/svg/png file types are allowed`, type: 'error'})
                return false;
            }
        }
        formData.append('botId', botId);

        if (files.length) {
            that.setState({ upLoading: true });
            let img = new Image();
            img.src = window.URL.createObjectURL(files[0]);
            img.onload = function () {
                let width = img.naturalWidth,
                    height = img.naturalHeight;

                window.URL.revokeObjectURL(img.src);
                if (width <= 148 && height <= 148 && width >= 24 && height >= 24) {
                    upload(files, false, (reponseUrl) => {
                        if (id === 1) {
                            that.setState({
                                image1: reponseUrl,
                                uploaded1: true,
                                upLoading: false
                            })
                        } else if (id === 2) {
                            that.setState({
                                image2: reponseUrl,
                                uploaded2: true,
                                upLoading: false
                            })
                        } else if (id === 3) {
                            that.setState({
                                image3: reponseUrl,
                                uploaded3: true,
                                upLoading: false
                            })
                        } else if (id === 4) {
                            that.setState({
                                image4: reponseUrl,
                                uploaded4: true,
                                upLoading: false
                            })
                        } else if (id === 5) {
                            that.setState({
                                image5: reponseUrl,
                                uploaded5: true,
                                upLoading: false
                            })
                        }
                    }, (err) => {
                        if (err && err.status && err.status === 401) {
                            that.props.reloginUser();
                        }
                        that.setState({ upLoading: false });
                    });
                }
                else {
                    that.setState({ upLoading: false });
                    rlibfn.showFlashMessage({message: `Please attach an image which is Min. 24 x 24 px and Max. 148 x 148 px with 72 DPI.`, type: 'error'})
                }
            };
        }
        else {
            console.log('File not found');
        }
    }

    render() {
        let ts = new Date().getTime();
        let tempId = parseInt(Math.random(10000) * 10000) + ts;
        return (
            <>
                <Popover
                    isOpen={this.state.popoverObj}
                    positions={['bottom', 'left', 'right']}
                    reposition={true}
                    padding={5}
                    margin={-15}
                    parentElement={document.getElementById('mainBodySection')}
                    onClickOutside={() => {
                        this.setState({ popoverObj: false })
                    }}
                    containerClassName='popover-menu-outer-wrapper multYimage-popover-wrapper-new'
                    content={({ position, childRect, popoverRect }) => (
                        <div className='popover-wrapper popover-menu-wrapper popover-align-left'
                            onClick={() => {
                                this.setState({ popoverObj: !this.state.popoverObj });
                            }}
                        > <ArrowContainer
                            position={position}
                            childRect={childRect}
                            popoverRect={popoverRect}
                            arrowColor={"#fff"}
                            arrowSize={12}
                            arrowStyle={{ opacity: 1 }}
                        >
                                <div className='popover-block popover-color-block'>
                                    <div className={'body-blocker-div-popover' + (this.state.upLoading ? ' active' : '')}></div>
                                    <p className='color-popover-description'>
                                        Upload Feedback Icons
                                        <p className='group-image-popover-desc'> ({this.state.groupDesc ? this.state.groupDesc : 'NA'}) </p>
                                    </p>
                                    <div className='config-value-info'>
                                        <div className='image-uploader-container'>
                                            <h4 className='title-for-image'>1.</h4>
                                            <label htmlFor={tempId + 1} className='image-upload-label' onClick={(e) => {
                                                e.stopPropagation();
                                            }}>
                                                {((this.props.hasImageData || !this.state.uploaded1 || this.state.image1 === '') && (!this.props.hasImageData || !this.props.custom.length)) && <img className='image-upload-label__attach-img' src={attachImage} alt='Attach Img' />}
                                                <span className='input-show-area'>
                                                    {!this.props.hasImageData && this.state.uploaded1 && this.state.image1 !== '' ? <img src={this.state.image1} alt='Attach Img' /> : ''}
                                                    {this.props.hasImageData && this.props.custom.length ? <img src={this.props.custom[0]} alt='Attach Img' /> : ''}
                                                </span>
                                                <input id={tempId + 1} type='file' accept="image/x-png, image/jpeg, image/svg" defaultValue={''} className='image-upload-input-field' onChange={(e) => { this.imageUploadValidation(e, 1) }} />
                                            </label>
                                        </div>
                                        <div className='image-uploader-container'>
                                            <h4 className='title-for-image'>2.</h4>
                                            <label htmlFor={tempId + 2} className='image-upload-label' onClick={(e) => {
                                                e.stopPropagation();
                                            }}>
                                                {((this.props.hasImageData || !this.state.uploaded2 || this.state.image2 === '') && (!this.props.hasImageData || !this.props.custom.length)) && <img className='image-upload-label__attach-img' src={attachImage} alt='Attach Img' />}
                                                <span className='input-show-area'>
                                                    {!this.props.hasImageData && this.state.uploaded2 && this.state.image2 !== '' ? <img src={this.state.image2} alt='Attach Img' /> : ''}
                                                    {this.props.hasImageData && this.props.custom.length ? <img src={this.props.custom[1]} alt='Attach Img' /> : ''}
                                                </span>
                                                <input id={tempId + 2} type='file' accept="image/x-png, image/jpeg, image/svg" defaultValue={''} className='image-upload-input-field' onChange={(e) => { this.imageUploadValidation(e, 2) }} />
                                            </label>
                                        </div>
                                        <div className='image-uploader-container'>
                                            <h4 className='title-for-image'>3.</h4>
                                            <label htmlFor={tempId + 3} className='image-upload-label' onClick={(e) => {
                                                e.stopPropagation();
                                            }}>
                                                {((this.props.hasImageData || !this.state.uploaded3 || this.state.image3 === '') && (!this.props.hasImageData || !this.props.custom.length)) && <img className='image-upload-label__attach-img' src={attachImage} alt='Attach Img' />}
                                                <span className='input-show-area'>
                                                    {!this.props.hasImageData && this.state.uploaded3 && this.state.image3 !== '' ? <img src={this.state.image3} alt='Attach Img' /> : ''}
                                                    {this.props.hasImageData && this.props.custom.length ? <img src={this.props.custom[2]} alt='Attach Img' /> : ''}
                                                </span>
                                                <input id={tempId + 3} type='file' accept="image/x-png, image/jpeg, image/svg" defaultValue={''} className='image-upload-input-field' onChange={(e) => { this.imageUploadValidation(e, 3) }} />
                                            </label>
                                        </div>
                                        <div className='image-uploader-container'>
                                            <h4 className='title-for-image'>4.</h4>
                                            <label htmlFor={tempId + 4} className='image-upload-label' onClick={(e) => {
                                                e.stopPropagation();
                                            }}>
                                                {((this.props.hasImageData || !this.state.uploaded4 || this.state.image4 === '') && (!this.props.hasImageData || !this.props.custom.length)) && <img className='image-upload-label__attach-img' src={attachImage} alt='Attach Img' />}
                                                <span className='input-show-area'>
                                                    {!this.props.hasImageData && this.state.uploaded4 && this.state.image4 !== '' ? <img src={this.state.image4} alt='Attach Img' /> : ''}
                                                    {this.props.hasImageData && this.props.custom.length ? <img src={this.props.custom[3]} alt='Attach Img' /> : ''}
                                                </span>
                                                <input id={tempId + 4} type='file' accept="image/x-png, image/jpeg, image/svg" defaultValue={''} className='image-upload-input-field' onChange={(e) => { this.imageUploadValidation(e, 4) }} />
                                            </label>
                                        </div>
                                        <div className='image-uploader-container'>
                                            <h4 className='title-for-image'>5.</h4>
                                            <label htmlFor={tempId + 5} className='image-upload-label' onClick={(e) => {
                                                e.stopPropagation();
                                            }}>
                                                {((this.props.hasImageData || !this.state.uploaded5 || this.state.image5 === '') && (!this.props.hasImageData || !this.props.custom.length)) && <img className='image-upload-label__attach-img' src={attachImage} alt='Attach Img' />}
                                                <span className='input-show-area'>
                                                    {!this.props.hasImageData && this.state.uploaded5 && this.state.image5 !== '' ? <img src={this.state.image5} alt='Attach Img' /> : ''}
                                                    {this.props.hasImageData && this.props.custom.length ? <img src={this.props.custom[4]} alt='Attach Img' /> : ''}
                                                </span>
                                                <input id={tempId + 5} type='file' accept="image/x-png, image/jpeg, image/svg" defaultValue={''} className='image-upload-input-field' onChange={(e) => { this.imageUploadValidation(e, 5) }} />
                                            </label>
                                        </div>
                                    </div>
                                    <div className='config-value-info'>
                                        <div className='color-container-popover'>
                                        </div>
                                    </div>
                                    <div className='go-float-right btn-wrapper'>
                                        <Button
                                            className='btn btn-default eb-btn-style eb-button-reclear'
                                            type='button'
                                            title='Clear'
                                            value={'Clear'}
                                            buttonOnClick={(e) => {
                                                this.setState({ image1: '', image2: '', image3: '', image4: '', image5: '', popoverObj: !this.state.popoverObj, uploaded1: false, uploaded2: false, uploaded3: false, uploaded4: false, uploaded5: false }, () => {
                                                    this.props.onUplaod(e, []);
                                                });
                                            }}
                                            style={{boxShadow: 'none'}}
                                        />
                                        <Button
                                            className='btn btn-default eb-btn-style'
                                            type='button'
                                            title='Close'
                                            value={'Close'}
                                            buttonOnClick={(e) => {
                                                this.setState({ image1: '', image2: '', image3: '', image4: '', image5: '', popoverObj: !this.state.popoverObj, uploaded1: false, uploaded2: false, uploaded3: false, uploaded4: false, uploaded5: false });
                                            }}
                                            style={{boxShadow: 'none'}}
                                        />
                                        <Button
                                            className='btn btn-default eb-btn-style eb-gradient-btn-linear'
                                            type='button'
                                            title='Apply'
                                            value={'Apply'}
                                            buttonOnClick={(e) => {
                                                if (this.state.image1 !== '' && this.state.image2 !== '' && this.state.image3 !== '' && this.state.image4 !== '' && this.state.image5 !== '') {
                                                    let tempVal1 = [];
                                                    tempVal1.push(this.state.image1);
                                                    tempVal1.push(this.state.image2);
                                                    tempVal1.push(this.state.image3);
                                                    tempVal1.push(this.state.image4);
                                                    tempVal1.push(this.state.image5);
                                                    this.props.onUplaod(e, tempVal1);
                                                    this.setState({ image1: '', image2: '', image3: '', image4: '', image5: '', popoverObj: !this.state.popoverObj, uploaded1: false, uploaded2: false, uploaded3: false, uploaded4: false, uploaded5: false });
                                                } else if (this.state.image1 !== '' && this.state.image2 !== '' && this.state.image3 !== '' && this.state.image4 === '' && this.state.image5 === '') {
                                                    // let tempVal = [];
                                                    // tempVal.push(this.state.image1);
                                                    // tempVal.push(this.state.image2);
                                                    // tempVal.push(this.state.image3);
                                                    // tempVal.length = 3;
                                                    this.props.onUplaod(e, [this.state.image1, this.state.image2, this.state.image3]);
                                                    this.setState({ image1: '', image2: '', image3: '', image4: '', image5: '', popoverObj: !this.state.popoverObj, uploaded1: false, uploaded2: false, uploaded3: false, uploaded4: false, uploaded5: false });
                                                } else if (this.state.image1 !== '' && this.state.image2 !== '' && this.state.image3 === '' && this.state.image4 === '' && this.state.image5 === '') {
                                                    // let tempVal = [];
                                                    // tempVal.push(this.state.image1);
                                                    // tempVal.push(this.state.image2);
                                                    // tempVal.push(this.state.image3);
                                                    // tempVal.length = 3;
                                                    this.props.onUplaod(e, [this.state.image1, this.state.image2]);
                                                    this.setState({ image1: '', image2: '', image3: '', image4: '', image5: '', popoverObj: !this.state.popoverObj, uploaded1: false, uploaded2: false, uploaded3: false, uploaded4: false, uploaded5: false });
                                                } else {
                                                    rlibfn.showFlashMessage({message: `Please upload first 2 images, 3 images Or all of 5 images to apply the changes`, type: 'error'})
                                                }
                                            }}
                                            style={{boxShadow: 'none'}}
                                        />
                                    </div>
                                </div>
                            </ArrowContainer>
                        </div>
                    )}
                >
                    <button className='eb-icon-btn-style' type='button' title='Upload Image' onClick={() => { this.setState({ image1: '', image2: '', image3: '', image4: '', image5: '', popoverObj: !this.state.popoverObj, uploaded1: false, uploaded2: false, uploaded3: false, uploaded4: false, uploaded5: false }); }}>
                        <span className='eb-icon-btn-image'>
                            <ImgTag
                                className='image'
                                src={addButtonWhite}
                                alt='More'
                            />
                        </span>
                    </button>
                </Popover>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        editableBotData: state.UiReducer && state.UiReducer.editableBotData ? state.UiReducer.editableBotData : {},
        genericBotData: state.UiReducer && state.UiReducer.genericBotData ? state.UiReducer.genericBotData : {}
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        updateBotValue,
        successGenericDataGet,
        blockUiFun,
        reloginUser
    },
        dispatch
    );
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MultyImagePopOver));